import type { V2Launcher } from '@/launchers/types';
import { CHAT_BAR_DISPLAY, evaluateUrlDisplayRules } from '@/lib/displayRules/evaluateUrlDisplayRules';

/**
 * Whether this page's rules let a launcher show at all. A rule's `display` choice picks
 * the chat bar slot's face, and a Button Prompts launcher has only the one, so it is set
 * aside here and each rule reads as its set's polarity says. Mapping a BUTTON verdict to
 * either answer would be wrong under one of the modes: it means "show" under
 * SHOW_ON_MATCH and stands in for a hide under HIDE_ON_MATCH.
 */
export function isLauncherVisible(launcher: V2Launcher, url?: string): boolean {
  const { displayRules } = launcher;
  const polarityOnly = displayRules && {
    ...displayRules,
    rules: displayRules.rules?.map(({ display: _display, ...rule }) => rule),
  };
  const { display } = evaluateUrlDisplayRules(polarityOnly, { id: `launcher "${launcher.id}"`, url });
  return display !== CHAT_BAR_DISPLAY.HIDDEN;
}
